module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), (_vm.update == true) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.product.name))])], 1), _vm._v(" "), _vm._m(0)] : _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Create a new product")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Product name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.name),
      expression: "fields.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('name')
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Product name",
      "data-vv-as": "Product name"
    },
    domProps: {
      "value": (_vm.fields.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "name", $event.target.value)
      }, function($event) {
        _vm.fields.slug = _vm.slug(_vm.fields.name, {
          lower: true
        })
      }]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('name')),
      expression: "veeErrors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('name')))])]), _vm._v(" "), (_vm.update == false) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Slug")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.slug),
      expression: "fields.slug"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|regex:^[a-z0-9]+(?:-[a-z0-9]+)*$'),
      expression: "'required|regex:^[a-z0-9]+(?:-[a-z0-9]+)*$'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('slug')
    },
    attrs: {
      "name": "slug",
      "type": "text",
      "placeholder": "product-slug",
      "data-vv-as": "Product slug"
    },
    domProps: {
      "value": (_vm.fields.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "slug", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('slug')),
      expression: "veeErrors.has('slug')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('slug')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button': true, 'is-primary': true, 'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": _vm.cancelUrl,
      "exact": ""
    }
  }, [_vm._v("Cancel")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Edit product name")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2492954"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products/ProductForm.vue
// module id = 230
// module chunks = 1